import { createSlice } from "@reduxjs/toolkit";

import {
  createTicketAction,
  forwardTicketAction,
  updateTicketAction,
  updateTicketStatusAction,
  addTicketCommentAction,
  getTicketDetailsAction,
  getTicketCommentsAction,
  ticketReducer,
  getTicketListAction,
  getAllTicketListAction,
  getTicketCategoryWiseCountAction,
  getTicketAssignedToUserAction,
} from "@/redux/support";
import { initialState } from "@/redux/support";
import { TicketTypes } from "@/redux/support/supportType";

export const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: ticketReducer,

  extraReducers: (builder) => {
    builder.addCase(createTicketAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      createTicketAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success: 0,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          message,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      createTicketAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );
    builder.addCase(forwardTicketAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      forwardTicketAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          message,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      forwardTicketAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(updateTicketAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateTicketAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          message,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      updateTicketAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(updateTicketStatusAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateTicketStatusAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          message,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      updateTicketStatusAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(addTicketCommentAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      addTicketCommentAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          message,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      addTicketCommentAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getTicketDetailsAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getTicketDetailsAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          message,
          success,
          ticketDetails: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getTicketDetailsAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getTicketCommentsAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getTicketCommentsAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          message,
          ticketComments: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getTicketCommentsAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getTicketListAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getTicketListAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, result, count, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          message,
          fetching: false,
          ticketList: result,

          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getTicketListAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(getAllTicketListAction.pending, (state: TicketTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getAllTicketListAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, result, count, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          message,
          allTicketList: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getAllTicketListAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );
    builder.addCase(
      getTicketCategoryWiseCountAction.pending,
      (state: TicketTypes) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      getTicketCategoryWiseCountAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          message,
          categoryWiseCountList: result,
          statusCode: status_code,
        };
      }
    );
    builder.addCase(
      getTicketCategoryWiseCountAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );
    builder.addCase(
      getTicketAssignedToUserAction.pending,
      (state: TicketTypes) => ({
        ...state,
        fetching: true,
      })
    );
    builder.addCase(
      getTicketAssignedToUserAction.fulfilled,
      (state: TicketTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          message,
          assignedToUserTicketsList: result,
          statusCode: status_code,
        };
      }
    );
    builder.addCase(
      getTicketAssignedToUserAction.rejected,
      (state: TicketTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );
  },
});

export const {
  resetTicketError,
  resetTicketSuccess,
  resetTicketDetails,
  resetTicketComments,
  resetTicketList,
  resetAllTicketList,
  resetTicketFetching,
  resetTicketMessage,
  resetTicketStatusCode,
} = supportSlice.actions;
